import { TableCell, TableRow } from "@material-ui/core"
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Tooltip } from '@material-ui/core';

export const ItemContacto = ({row,handleClick,index,isSelected}) =>{
    const isItemSelected = isSelected(row.apellido_y_nombre);
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow
            hover
            onClick={(event) => handleClick(event, row.name)}
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            key={row.name}
            selected={isItemSelected}
        >
            <TableCell>
                {row.estado===2? <Tooltip title='Contacto mail confirmado' placement="right-end"><CheckCircleOutlineIcon style={{color:'green'}}/></Tooltip> : <Tooltip title='Contacto mail pendiente' placement="right-end"><ErrorOutlineIcon style={{color:'#ffc107'}}/></Tooltip>}
            </TableCell>
            <TableCell component="th" id={labelId} scope="row" padding="none">
            {row.cuil}
            </TableCell>
            <TableCell align="right">{row.apellido_y_nombre}</TableCell>
            <TableCell align="right">{`${row.domiciliosAfiliados.calle} ${row.domiciliosAfiliados.nro}`}</TableCell>
            <TableCell align="right">{row.domiciliosAfiliados.mail}</TableCell>
        </TableRow>
)
}